"use client";

import { c as _c } from "react/compiler-runtime";
import { Text, HStack, VStack, Link, Card, Spinner, Popover, Portal, Switch, SystemStyleObject } from "@chakra-ui/react";
import posthog from "posthog-js";
import Pill from "./pill";
import { RxCross2 } from "react-icons/rx";
import { PillData, LayerIds } from "../data/data";
import { FaCircle, FaSquareFull } from "react-icons/fa";
import { KeyElem } from "./key-elem";
import { Dispatch, SetStateAction, useState } from "react";
import { LayerToggleObjProps } from "./address-mapper";
interface CardHazardProps {
  hazard: {
    id: number;
    name: string;
    title: string;
    description: string;
    info: string[];
    link: {
      label: string;
      url: string;
    };
    icon: string;
    iconColor: SystemStyleObject["color"];
  };
  hazardData?: {
    exists?: boolean;
    last_updated?: string;
  };
  showData: boolean;
  isHazardDataLoading: boolean;
  toggledStates: boolean[];
  setToggledStates: Dispatch<SetStateAction<boolean[]>>;
  setLayerToggleObj: Dispatch<SetStateAction<LayerToggleObjProps>>;
}
const CardHazard: React.FC<CardHazardProps> = t0 => {
  const $ = _c(70);
  const {
    hazard,
    hazardData,
    showData,
    isHazardDataLoading,
    toggledStates,
    setToggledStates,
    setLayerToggleObj
  } = t0;
  const {
    id,
    title,
    name,
    description,
    icon,
    iconColor
  } = hazard;
  let t1;
  if ($[0] !== hazardData) {
    t1 = hazardData || {};
    $[0] = hazardData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    exists
  } = t1;
  let t2;
  if ($[2] !== name) {
    t2 = PillData.find(object => object.name === name) ?? {
      trueData: "No Data",
      falseData: "No Data",
      noData: "No Data"
    };
    $[2] = name;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const pillTextOptions = t2;
  const [isMoreInfo, setIsMoreInfo] = useState(false);
  let t3;
  if ($[4] !== exists || $[5] !== isHazardDataLoading || $[6] !== pillTextOptions || $[7] !== showData) {
    t3 = isHazardDataLoading ? <Spinner size="xs" /> : showData ? <Pill exists={exists} trueData={pillTextOptions.trueData} falseData={pillTextOptions.falseData} noData={pillTextOptions.noData} /> : "";
    $[4] = exists;
    $[5] = isHazardDataLoading;
    $[6] = pillTextOptions;
    $[7] = showData;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const hazardPill = t3;
  let t4;
  if ($[9] !== hazard.info) {
    t4 = () => hazard.info.map(_temp);
    $[9] = hazard.info;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const buildHazardCardInfo = t4;
  let t5;
  if ($[11] !== setLayerToggleObj || $[12] !== setToggledStates || $[13] !== toggledStates) {
    t5 = (num, checked) => {
      const newArray = [...toggledStates];
      newArray[num] = checked;
      setToggledStates(newArray);
      setLayerToggleObj({
        layerId: LayerIds[num],
        toggleState: checked
      });
    };
    $[11] = setLayerToggleObj;
    $[12] = setToggledStates;
    $[13] = toggledStates;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const handleSwitchClick = t5;
  let t6;
  let t7;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      base: "xs",
      "2xl": "sm"
    };
    t7 = {
      base: "3.5",
      md: "4"
    };
    t8 = {
      base: "4",
      md: "5"
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      placement: "bottom",
      flip: false,
      offset: {
        crossAxis: -12,
        mainAxis: 24
      },
      sameWidth: true
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = `${hazard.title} information`;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e => setIsMoreInfo(e.open);
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== icon) {
    t12 = icon === "circle" ? <FaCircle /> : <FaSquareFull />;
    $[20] = icon;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== iconColor || $[23] !== t12 || $[24] !== title) {
    t13 = <KeyElem name={title} color={iconColor} icon={t12} />;
    $[22] = iconColor;
    $[23] = t12;
    $[24] = title;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = toggledStates[id];
  let t15;
  if ($[26] !== handleSwitchClick || $[27] !== id) {
    t15 = e_0 => handleSwitchClick(id, e_0.checked);
    $[26] = handleSwitchClick;
    $[27] = id;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  let t17;
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Switch.HiddenInput />;
    t17 = <Switch.Control />;
    t18 = <Switch.Label />;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t16 = $[29];
    t17 = $[30];
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t14 || $[33] !== t15) {
    t19 = <Switch.Root size="lg" colorPalette="blue" checked={t14} onCheckedChange={t15} defaultChecked={true} gap="0">{t16}{t17}{t18}</Switch.Root>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t13 || $[36] !== t19) {
    t20 = <Card.Header w="full" p="0" mb="1" textAlign="left" flexDirection="row" justifyContent="space-between">{t13}{t19}</Card.Header>;
    $[35] = t13;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== description) {
    t21 = <Card.Body textAlign="left" p="0" mb="1.5"><Text textStyle="cardTextMedium" layerStyle="text">{description}</Text></Card.Body>;
    $[38] = description;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== hazard.name || $[41] !== isMoreInfo) {
    t22 = () => {
      if (!isMoreInfo) {
        posthog.capture("more-info-clicked", {
          hazard_name: hazard.name
        });
      }
    };
    $[40] = hazard.name;
    $[41] = isMoreInfo;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  const t23 = !isMoreInfo ? "More info" : "Less info";
  let t24;
  if ($[43] !== t22 || $[44] !== t23) {
    t24 = <Popover.Trigger><Text cursor="button" textDecoration="underline" onClick={t22}>{t23}</Text></Popover.Trigger>;
    $[43] = t22;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== hazardPill || $[47] !== t24) {
    t25 = <Card.Footer p="0" width="full"><HStack justifyContent="space-between" width="full">{t24}{hazardPill}</HStack></Card.Footer>;
    $[46] = hazardPill;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t20 || $[50] !== t21 || $[51] !== t25) {
    t26 = <VStack alignItems="flex-start" flexGrow={1} h="full">{t20}{t21}{t25}</VStack>;
    $[49] = t20;
    $[50] = t21;
    $[51] = t25;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Popover.CloseTrigger cursor="button" position="absolute" top="2" right="2"><RxCross2 color="grey.900" size="20" data-testid="clear-icon" /></Popover.CloseTrigger>;
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Popover.Arrow><Popover.ArrowTip /></Popover.Arrow>;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== buildHazardCardInfo) {
    t29 = buildHazardCardInfo();
    $[55] = buildHazardCardInfo;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== hazard.link.label) {
    t30 = () => posthog.capture("dataset-link-clicked", {
      link_name: hazard.link.label
    });
    $[57] = hazard.link.label;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== hazard.link.label || $[60] !== hazard.link.url || $[61] !== t30) {
    t31 = <Link display="inline-block" href={hazard.link.url} mt="4" target="_blank" textDecoration="underline" onClick={t30}>{hazard.link.label}</Link>;
    $[59] = hazard.link.label;
    $[60] = hazard.link.url;
    $[61] = t30;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t29 || $[64] !== t31) {
    t32 = <Portal><Popover.Positioner><Popover.Content maxHeight="unset">{t27}{t28}<Popover.Body>{t29}{t31}</Popover.Body></Popover.Content></Popover.Positioner></Portal>;
    $[63] = t29;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== t10 || $[67] !== t26 || $[68] !== t32) {
    t33 = <Card.Root flex={1} maxW={t6} py={t7} px={t8} shadow="card" variant="elevated"><Popover.Root positioning={t9} closeOnEscape={true} closeOnInteractOutside={true} aria-label={t10} onOpenChange={t11}>{t26}{t32}</Popover.Root></Card.Root>;
    $[66] = t10;
    $[67] = t26;
    $[68] = t32;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  return t33;
};
export default CardHazard;
function _temp(infoItem, index) {
  return <Text as="p" mt="4" key={index}>{infoItem}</Text>;
}